/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


// Open popup
  document.querySelectorAll('.image-with-text__popup a[href^="#popup-"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const popupId = trigger.getAttribute('href');
      const popup = document.querySelector(popupId);
      if (popup) popup.classList.add('active');
    });
  });

  // Close popup when clicking the close icon or background
  document.querySelectorAll('.image-with-text__popup-modal').forEach(popup => {
    popup.addEventListener('click', e => {
      if (e.target === popup || e.target.closest('.modal-close')) {
        popup.classList.remove('active');
      }
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
